export default __webpack_public_path__ + "static/media/relax.200d864a.svg";